import oc from 'octobercms';
import { Notyf } from "notyf";

export default new class Callback {
  constructor() {
    this.contactFormSelector = 'callback__form';
    this.contactInputSelector = 'callback__input';
    this.submitBtnSelector = 'callback__form_button';
    this.inValidSelector = '_invalid';
    this.successSelector = 'contact__success';
    this.successVisibleSelector = 'contact__success_visible';
    this.preLoaderSelector = 'contact__preloader';
    this.delay = 2000;

    this.handler();
  }

  handler() {
    const form = document.querySelector(`.${this.contactFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      setTimeout(() => {
        this.checkForm(form);
      }, 100);
    });
  }

  checkForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    const thankyou = document.querySelector('.callback__thankyou');
    const inputs = form.querySelectorAll(`.${this.contactInputSelector}`);
    const values = {};

    inputs.forEach((input) => {
      values[`${input.name}`] = input.value;
    });

    oc.ajax('ContactForm::onSave', {
      data: values,
      loading: `.${this.preLoaderSelector}`,
      success: (res) => {
        // this.notificaton(res);
        if (res.status === true) {
          this.clearInputs(form);
        };

        form.classList.add('callback__form--hidden');
        thankyou.classList.add('callback__thankyou--visible');
        setTimeout(() => {
          form.classList.remove('callback__form--hidden');
          thankyou.classList.remove('callback__thankyou--visible');
        }, 8000);
      },
    });
  }

  notificaton(res) {
        const notyf = new Notyf({
            position: {x:'center',y:'top'}
        });
        if (res.status === false) {
            notyf.error(res.message);
        } else {
            notyf.success(res.message);
        }
  }

  clearInputs(form) {
   form.reset();
  };

}();
